export const ROOM_RESERVATIONS_PERMISSIONS = {
    CREATE: 'room_reservations_create',
    DELETE: 'room_reservations_delete',
    ADMIN_DELETE: 'room_reservations_admin_delete',
    ON_BEHALF: 'room_reservations_on_behalf',
    ROOMS_CONFIG: 'room_reservations_rooms_config',
    NEW: 'room_reservations_new'
} as const
